export enum EventSubCategories {
  EVENTS = `EVENTS`,
}
